export enum InvoiceDetailView {
	view = 'view',
	edit = 'edit',
}
